'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./savingSchemes/createScheme'));
    processInclude(require('./savingSchemes/formValidation'));
    processInclude(require('./savingSchemes/confirmationPage'));
    processInclude(require('./savingSchemes/quickPay'));
});
